import Vue from 'vue'
import yxqnPrompt from './yxqnPrompt.vue'

let newInstance = null
// 将vue组件进行构造函数转换
const ConfirmConstructor = Vue.extend(yxqnPrompt)
const init = (options) => {
// 将组件实例化
  newInstance = new ConfirmConstructor({
    el: document.createElement('div')
  })
  // 加载dom
  document.body.appendChild(newInstance.$el)
}
const caller = (options) => {
// options 调用时传入配置项
//   console.log(options)
//   console.log(newInstance)
  if (!newInstance) {
    init(options)
  }
  for (const prop in options) {
    if (options.hasOwnProperty(prop)) {
      newInstance[prop] = options[prop]
    }
  }
  newInstance.textArea = ''
  Vue.nextTick(() => {
    newInstance.open = true
  })
  return newInstance.show(options)
}
export default {
  install (vue) {
    vue.prototype.$yxqnPrompt = caller
  }
}
